export default __webpack_public_path__ + "static/RichardFife-8fcaca411809577a8d80e34eeeab6ceb.jpg";